import React, { PureComponent } from 'react'
import moment from 'moment'
import cx from 'classnames'

import s from './DateTime.scss'


class DateTime extends PureComponent {

  timeout = null

  state = {
    time: moment().format('HH:mm'),
    date: moment().format('DD.MM.YYYY'),
    weekDay: moment().format('dddd'),
  }

  componentDidMount() {
    this.setUpdate()
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  setUpdate = () => {
    this.setState({
      time: moment().format('HH:mm'),
      date: moment().format('DD.MM.YYYY'),
      weekDay: moment().format('dddd'),
    })

    this.timeout = setTimeout(this.setUpdate, 1000)
  }

  render() {
    const { className, time, date, weekDay } = this.state

    return (
      <div className={cx(s.dateTime, className)}>
        <div className={s.time}>{time}</div>
        <div className={s.date}>
          <div className={s.weekDay}>{weekDay}</div>
          <div>{date}</div>
        </div>
      </div>
    )
  }
}


export default DateTime
